import { render, staticRenderFns } from "./TrainingQuizQuestionTypeSimple.vue?vue&type=template&id=746ac349&"
import script from "./TrainingQuizQuestionTypeSimple.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizQuestionTypeSimple.vue?vue&type=script&lang=js&"
import style0 from "./TrainingQuizQuestionTypeSimple.vue?vue&type=style&index=0&id=746ac349&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports